import { render, staticRenderFns } from "./BaseModalAlert.vue?vue&type=template&id=11fe5924&"
import script from "./BaseModalAlert.vue?vue&type=script&lang=js&"
export * from "./BaseModalAlert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports